// extracted by css-extract-rspack-plugin
export default {"container":"container-lEsQQf","header":"header-yBoC4i"};